import React  from 'react'
import PropTypes from 'prop-types'

import {throttle, debounce} from 'lodash'

import Day from './Day'
import CalendarSlider from './CalendarSlider'
import './styles.less'

import Api from '../../Api.js'

const Slider = new CalendarSlider({
	page_size:  100,
	start_days: 365,
	max_year:   10,
})


class DaySelector extends React.Component {

	constructor() {
		super()
		this.scrollPosition = throttle(this.scrollPosition, 50)
		this.scrollEnd      = debounce(this.scrollEnd, 500)
	}

	componentWillMount() {
		this.setState({
			month: Slider.now_month,
			days:  Slider.getPageDays(),
			info:  {},
			right_space:99999999999999
		})
	}

	componentDidMount() {
		Slider.setParams({
			day_block_width:this.refs.list.querySelector('.day').getClientRects()[0].width
		})

		Slider.selectToday()
		this.getDaysPrices()

		this.scrollTo( Slider.getCurDayOffset(), 300, ()=>{
		})		
		this.props.onDaySelect( Slider.getTodayTime() )
	}
	

	onScroll(){
		this.scrolling = true
		if (this.selfscroll) { return }

		this.scrollPosition()
		this.scrollEnd()
	}

	scrollPosition(){
		let res = Slider.scroll( this.refs.list.scrollLeft )
		
		// Апдейтим если дни или месяц сменился
		if (!res.update && this.state.month!==Slider.month) {
			this.setState({month:Slider.month})
		}

		if (res.update) {
			this.setState({
				month:       Slider.month,
				days:        Slider.getPageDays(),
				left_space:  Slider.left_offset,
			})
		}

		if (res.end) {
			this.setState({right_space: 0})
		}
	}

	scrollTo(offset, duration='auto', callback){
		this.selfscroll = true

		let list = this.refs.list

		if (duration==='auto') {
			duration = Math.abs(offset-list.scrollLeft)*3
		}

		let animate = (s_pos, to, time)=>{
			let start = new Date().getTime()
			
			let loop = ()=>{
				var step = Math.min(1, (new Date().getTime() - start) / time)

				list.scrollLeft = (s_pos + step * (to - s_pos))
				
				if (step === 1) {
					this.selfscroll = false
					callback()
					return
				}
				requestAnimationFrame(loop)
			}
			requestAnimationFrame(loop)
		}

		animate(list.scrollLeft, offset, duration)

	}

	scrollEnd(){
		this.scrolling = false
		this.getDaysPrices()
	}
	
	getDaysPrices(){
		clearTimeout(this.t)
		this.t = setTimeout(()=>{
			let cur_day_i = Slider.getCurDayIndex()
			let start_i   = cur_day_i-5
			let end_i     = cur_day_i+5

			if (start_i<=0) { start_i = 0 }
			
			let days = Slider.getPageDays()

			let screen_days = days.slice(start_i, end_i)

			Api.getDaysInfo(screen_days, (days)=>{
				let info = {}
				days.forEach((d)=>{
					info[d.timestamp] = d.min_price
				})

				this.setState({info:info})
			})	
		},1000)
	}

	selectDay(timestamp, element){		
		Slider.selectDay( Slider.getDayByTime(timestamp) )
		
		requestAnimationFrame(()=>{
			this.refs.list.getElementsByClassName('active')[0].classList.remove('active')
			element.classList.add('active')
			document.getElementsByClassName('fligths')[0].classList.add('loading')
		})

		this.scrollTo( Slider.getCurDayOffset() , 'auto', ()=>{
			setTimeout(()=>{
				this.props.onDaySelect(timestamp)
				this.setState({})			
			},100)
		})
	}

	render() {
		return (
			<div className="calendar">
				<h3><i>📅</i> {this.state.month}</h3>

				<div className="slider-wrap">
					<div className="loader"><i></i></div>
					
					<div ref="list"
						className="days-list" 
						onScroll={this.onScroll.bind(this)}
					>
						<div className="spacer" style={{width: this.state.left_space}}></div>
						{this.state.days.map((day)=>{
							const day_info = this.state.info[day.timestamp]
							return <Day 
								onSelect={this.selectDay.bind(this)}
								timestamp={day.timestamp} 
								active={day.active} 
								disabled={day.disabled} 
								desc={day_info} 
								key={day.key}
							/>
						})}
						<div className="spacer" style={{width: this.state.right_space}}></div>
					</div>
				</div>
			</div>
		)
	}
}


DaySelector.propTypes = {
	onDaySelect: PropTypes.func
}

export default DaySelector


// WEBPACK FOOTER //
// ./src/components/DaySelector/index.js